import gql from 'graphql-tag';

export default gql`
  query getSignature($merchantId: String!, $amount: Float!, $merchantReferenceCode: String!) {
    signature(merchantId: $merchantId, amount: $amount, merchantReferenceCode: $merchantReferenceCode) {
      value
    }
  }
`;



// WEBPACK FOOTER //
// ./src/app/queries/getSignature.js